module.exports = __webpack_public_path__ + "static/media/modal_cloud_dark.95b1f7e9.svg";